import { CreateAiSuggestionRequest, DecisionResponse, OpenAiResultReponse, PutDecisionRequest } from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Decision';

export const getDecision = async (id: string): Promise<HttpResponse<DecisionResponse>> => {
	const result = await makeRequest<string, DecisionResponse>(`${endpoint}?decisionId=${id}`, null, 'get');
	return result;
};

export const putDecision = async (request: PutDecisionRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<PutDecisionRequest, string>(`${endpoint}`, request, 'put');
	return result;
};

export const createAISuggestion = async (request: CreateAiSuggestionRequest): Promise<HttpResponse<OpenAiResultReponse>> => {
	const result = await makeRequest<CreateAiSuggestionRequest, OpenAiResultReponse>(`${endpoint}/suggestion`, request, 'post');
	return result;
};

export const getAISuggestions = async (caseId: string): Promise<HttpResponse<OpenAiResultReponse[]>> => {
	const result = await makeRequest<string, OpenAiResultReponse[]>(`${endpoint}/suggestions/${caseId}`, null, 'get');
	return result;
};
